export default __webpack_public_path__ + "static/media/ra-urban.97a329ce.svg";